import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { AdminChallengeContent, Challenge, ChallengeType } from '../../services/models/challenges.model';
import { Router } from '@angular/router';
import { SearchModel } from '../../../models/search-model';
import { AnalyticsService } from '../../../_core/analytics/analytics.service';
import { ConfigService } from '../../../services/config.service';

@Component({
  selector: 'app-challenges-admin-card',
  templateUrl: './challenges-admin-card.component.html',
  styleUrls: ['./challenges-admin-card.component.scss']
})
export class ChallengesAdminCardComponent {

  @Input() challenge!: Challenge<AdminChallengeContent>;
  @Output() viewContents = new EventEmitter<void>();

  private readonly analyticsService = inject(AnalyticsService);
  private readonly configService = inject(ConfigService);

  constructor(
    private readonly router: Router,
  ) {
  }

  getChallengeCreatedByLabel(): string {
    return this.challenge.isPublic ? 'challenges.createdByAdmin' : 'challenges.createdByAdminPrivate';
  }

  getChallengeProgressTitleLabel(): string {
    switch (this.challenge.type) {
      case ChallengeType.TITLES_READ_CHALLENGE:
      case ChallengeType.CHECKOUT_TITLES_CHALLENGE:
        return 'challenges.consumedContent';
      case ChallengeType.READING_TIME_CHALLENGE:
        return 'general.pluralHour';
      default:
        return '';
    }
  }

  showContents() {
    const searchModel = new SearchModel(undefined, this.configService.get().resultsFilterOrder);

    this.analyticsService.searchPerformedOrigin = 'challenge';
    this.router.navigate(['/results'], {
      queryParams: {
        ...searchModel.toRequest(),
        title: this.challenge.name,
        showReturnButton: true,
        hideButtonsSideMenu: true,
        originPage: '/user/challenges',
        challengeId: this.challenge.id,
      },
    });
  }
}
